// extracted by mini-css-extract-plugin
export default {"prevent-overflow":"CustomersList_prevent-overflow__eHfm4"};